export default function FormField({
  label,
  htmlFor,
  optional,
  children
}: {
  children: React.ReactNode;
  htmlFor: string;
  label: string;
  optional?: boolean;
}) {
  return (
    <div className="flex w-full flex-col gap-2">
      <label
        className="flex items-baseline gap-1 font-heading font-medium"
        htmlFor={htmlFor}
      >
        {label}
        {optional && (
          <span className="text-sm font-normal text-grey-hide">(optional)</span>
        )}
      </label>
      {children}
    </div>
  );
}
